module.exports = __webpack_public_path__ + "img/laravel-fullstack-app7.46cfa7ea.png";